/** @format — Chat thread loading placeholder */

import React from "react";
import Dockie from "@/assets/dockie-preview.png";

function BubbleSkeleton({ align = "left", wide = false, showAvatar = true }) {
  const alignClass = align === "right" ? "justify-end" : "justify-start";
  return (
    <div className={`flex ${alignClass} mb-4 animate-pulse`}>
      {align === "left" && showAvatar ? (
        <div className="w-8 h-8 rounded-full bg-[#E4E7EC] flex-shrink-0 mr-3 mt-1" />
      ) : null}
      <div
        className={`rounded-2xl bg-[#E4E7EC] ${
          wide ? "h-24 w-[min(100%,320px)]" : "h-14 w-[min(85%,240px)]"
        } ${align === "right" ? "rounded-br-md" : "rounded-bl-md"}`}
      />
    </div>
  );
}

export function ChatConversationSkeleton({ rows = 3, showAvatar = true }) {
  return (
    <div className="flex flex-col px-6 py-6 w-full">
      {showAvatar ? (
        <div className="flex justify-center mb-6">
          <div className="h-3 w-40 bg-[#F2F4F7] rounded animate-pulse" />
        </div>
      ) : null}
      <BubbleSkeleton align="right" showAvatar={showAvatar} />
      <div className="flex justify-start mb-4">
        {showAvatar ? (
          <img src={Dockie} alt="" className="w-8 h-8 rounded-full flex-shrink-0 mr-3 mt-1 opacity-40" />
        ) : null}
        <div className="flex flex-col gap-2 flex-1 max-w-[320px] animate-pulse">
          <div className="h-4 bg-[#E4E7EC] rounded w-3/4" />
          <div className="h-32 bg-[#F2F4F7] rounded-xl w-full" />
          <div className="h-3 bg-[#E4E7EC] rounded w-1/2" />
        </div>
      </div>
      {rows > 1 ? <BubbleSkeleton align="right" wide showAvatar={showAvatar} /> : null}
    </div>
  );
}

export default ChatConversationSkeleton;
